import type { ProjectMember as GraftProjectMember } from '@graft/nuget-gc.webportals.projects'

import { readGraftObject } from '@common/utils/readGraftObject'

import { MemberLevel, MemberStatus } from '../project-members.enum'
import type { WorkspaceMember } from '../project-members.interface'
import type { ProjectMember } from '../projects.type'

export async function projectMemberToObject(entity: GraftProjectMember, projectId: string): Promise<WorkspaceMember> {
  const dto = await readGraftObject<ProjectMember>(entity)

  const nameParts = [dto.firstName, dto.lastName].flatMap((part) => {
    const trimmed = part?.trim()
    return trimmed ? [trimmed] : []
  })
  const name = nameParts.length ? nameParts.join(' ') : null
  const emailValue = dto.email ?? ''
  const id = dto.userId || emailValue || `project-member-${projectId}-${name ?? 'unknown'}`
  const role = dto.level === MemberLevel.ADMIN ? MemberLevel.ADMIN : MemberLevel.DEVELOPER

  return {
    id,
    name,
    email: emailValue,
    avatarUrl: dto.avatarUrl?.trim() || null,
    role,
    status: MemberStatus.ACTIVE,
    lastSeen: null,
    projectIds: [projectId],
  }
}
